import { VNode, h, defineComponent } from 'vue';
import { pageSubtitleUnsafe } from '@/ui/components/PageSubtitle';

interface EmptyStateEntryProps {
  imageSrc: string;
  title?: string | VNode | null;
  text?: string;
  classes?: string;
}

export default defineComponent<EmptyStateEntryProps>({
  props: ['imageSrc', 'title', 'text', 'button', 'classes'],
  setup(props, context) {
    return function render() {
      return h('div', { class: `column empty-state-entry ${props.classes ?? ''}` }, [
        h('img', {
          class: 'empty-state-entry__img',
          attrs: { src: props.imageSrc },
        }),
        typeof props.title === 'string' ? pageSubtitleUnsafe(props.title, 'empty-state-entry__title') : props.title,
        h('p', { class: 'empty-state-entry__text' }, [
          props.text,
          context.slots.text?.(),
        ]),
        context.slots.button?.(),
      ]);
    };
  },
});

/** @deprecated Many components still use this function, but they should be replaced with the component above */
export const emptyEntry = (
  imageSrc: string,
  title?: string | VNode | null,
  text?: string,
  button?: VNode | null,
  classes?: string,
) => h('div', { class: `column empty-state-entry ${classes}` }, [
  h('img', {
    class: 'empty-state-entry__img',
    attrs: { src: imageSrc },
  }),
  typeof title === 'string' ? pageSubtitleUnsafe(title, 'empty-state-entry__title') : title,
  h('p', { class: 'empty-state-entry__text' }, text),
  button,
]);
